import { FlatList } from 'react-native';
import styled from 'styled-components/native';

import Separator from '@src/components/Separator';
import {
  idKeyExtractor,
  journeyNumColumns,
  padding,
} from '@src/configuration/constants';
import { Journey } from '@src/types';

export const List = styled(FlatList as new () => FlatList<Journey>).attrs(
  () => ({
    removeClippedSubviews: true,
    initialNumToRender: 20,
    maxToRenderPerBatch: 20,
    scrollEventThrottle: 16,
    keyExtractor: idKeyExtractor,
    showsHorizontalScrollIndicator: false,
    ItemSeparatorComponent: Separator,
    contentContainerStyle: {
      paddingBottom: padding,
    },
    columnWrapperStyle: {
      justifyContent: 'space-evenly',
    },
    numColumns: journeyNumColumns,
  })
)``;
